<div class="content-layout fullwidth-standard-normal-scroll">
  <div class="content">
    <div class="flex flex-auto" *ngIf="sharedResource">
      <div class="flex flex-col w-1/3 border-right" *ngFor="let panelCol of panels; let i = index">
        <ng-container *ngFor="let panelDef of panelCol">
          <project-panel
            [panelDef]="panelDef"
            [project]="project"
            [account]="account"
            [data]="data"
            (onEditPanelDef)="onEditPanelDef($event)"
            [readonly]="true"
            [canEditPanelDef]="false"
          ></project-panel>
        </ng-container>
      </div>
    </div>
  </div>
</div>
